import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { Toast } from 'antd-mobile'

// ------------------------------------
// Constants
// ------------------------------------
export const MOBILE_TRANSFER_RECEIVE = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  SUBMIT_REQUEST: null,
  SUBMIT_SUCCESS: null,
  QUERY_REQUEST: null,
  QUERY_SUCCESS: null,
}, 'MOBILE_TRANSFER_RECEIVE')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: '/cgs/api/personal/transfer/mobile/query',
        requestAction: MOBILE_TRANSFER_RECEIVE.INIT_REQUEST,
        successAction: MOBILE_TRANSFER_RECEIVE.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function submit(data) {
  Toast.loading('', 0)
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: '/cgs/api/personal/transfer/mobile/receipt',
        requestAction: MOBILE_TRANSFER_RECEIVE.SUBMIT_REQUEST,
        successAction: MOBILE_TRANSFER_RECEIVE.SUBMIT_SUCCESS,
        success: function(result) {
          dispatch(query(data))
        },
      })
    )
  }
}

export function query(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: '/cgs/api/personal/transfer/status/query',
        requestAction: MOBILE_TRANSFER_RECEIVE.QUERY_REQUEST,
        successAction: MOBILE_TRANSFER_RECEIVE.QUERY_SUCCESS,
        success: function(result) {
          if (result.orderStatus === 'RECEIVE_PROCESSING') {
            return dispatch(query(data))
          }
          Toast.hide()
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [MOBILE_TRANSFER_RECEIVE.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [MOBILE_TRANSFER_RECEIVE.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [MOBILE_TRANSFER_RECEIVE.SUBMIT_REQUEST]: (state, action) => state,
  [MOBILE_TRANSFER_RECEIVE.SUBMIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [MOBILE_TRANSFER_RECEIVE.QUERY_REQUEST]: (state, action) => state,
  [MOBILE_TRANSFER_RECEIVE.QUERY_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'mobileTransferReceive',
    reducerMap: {
      mobileTransferReceiveState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
